import React from 'react';
import { Box } from '@mui/material';
import {
  Hero,
  WhyUs,
  SavingsCalculator,
  Pricing,
  About,
  Testimonials,
  Team,
  Contact,
} from '../../components/sections';

const Home = () => {
  return (
    <Box>
      <Hero />
      <WhyUs />
      <SavingsCalculator />
      <Pricing />
      <About />
      <Testimonials />
      <Team />
      <Contact />
    </Box>
  );
};

export default Home;
